import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/membershipLengthSagas";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

const CategoryFilter = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.membershipLengthByAgreement.isCategoriesLoading);

  const options = useSelector((state) => state.membershipLengthByAgreement.filters.categories);
  const selectedOption = useSelector(
    (state) => state.membershipLengthByAgreement.selectedFilters.categories
  );

  return (
    <div className="select-box" style={{ width: "145px" }}>
      <p>Category</p>
      {isLoading ? (
        <LoadingAnimation uiLoader />
      ) : (
        <MultiSelectDropdown
          options={options}
          selectedFilters={selectedOption}
          includeFilter
          enableOnly
          height={324}
          includeSelectAll
          numberDisplayed={0}
          onSelectChange={(data) => dispatch(actionCreators.updateCategories(data))}
        />
      )}
    </div>
  );
};

export default CategoryFilter;
